import Vue from 'vue';
import { Swiper } from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
var swiper = {
    // @ts-ignore
    install: function () {
        Vue.prototype.$swiper = Swiper;
        Vue.prototype.$swiperModules = {
            Pagination: Pagination,
            Navigation: Navigation,
            Autoplay: Autoplay
        };
    }
};
Vue.use(swiper);
